module.exports = __webpack_public_path__ + "img/comingsoon_bridge_1.07690431.png";